var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 31,
    viewBox: "0 0 38 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.1744 0.885477C6.37968 0.543333 6.74943 0.333984 7.14844 0.333984H30.8523C31.2513 0.333984 31.6211 0.543332 31.8264 0.885477L37.3123 10.0286C37.5684 10.4555 37.5167 10.9995 37.1847 11.3705L20.0416 30.5304C19.9059 30.669 19.7439 30.779 19.5651 30.8542C19.3863 30.9293 19.1943 30.968 19.0004 30.968C18.8064 30.968 18.6145 30.9293 18.4357 30.8542C18.2569 30.779 18.0949 30.669 17.9591 30.5304L0.816009 11.3705C0.48405 10.9995 0.432362 10.4555 0.6885 10.0286L6.1744 0.885477Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.26413f28baf35a1dfeb1b25d3d044df1.svg";
export { ForwardRef as ReactComponent };